var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"d-flex items-center m-0"},[_c('img',{staticClass:"m-0 mr-1",attrs:{"src":require('@/assets/imgs/2025/icons/play-mode-icon.png'),"width":"20px","alt":""}})]),_c('div',[_c('h6',{staticClass:"play-mode text-nowrap m-0"},[_vm._v(_vm._s(_vm.playMode))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }